import { TooltipContentProps, TooltipProviderProps } from "@radix-ui/react-tooltip";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";

export interface SimpleTooltipProps extends TooltipProviderProps, Pick<TooltipContentProps, "side" | "align"> {
    message: string;
    asChild?: boolean;
    /** Bubble classes, for a caller that has to bound a long message. */
    contentClassName?: string;
}

export function SimpleTooltip({ message, children, asChild, side, align, contentClassName, ...props }: SimpleTooltipProps) {
    return (
        <TooltipProvider {...props}>
            <Tooltip>
                <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
                <TooltipContent side={side} align={align} className={contentClassName}>
                    <p>{message}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
